export const selectCurrentUser = (state) => state.user.currentUser;

export const selectIsAccountCardOpen = (state) => state.user.isAccountCardOpen;